<template>
  <div class="page choose-page">
    <van-nav-bar class="nav-bar nav-bar-gradient" :title="$t('concubine.concubine')">
      <template #right>
        <van-image width="18" height="18" src="/img/clm.png" style="margin-right: 12px;" @click="isShow=false" />
        <van-image width="22" height="22" src="/img/row.png" @click="isShow=true" />
      </template>
    </van-nav-bar>

    <div class="banner-wrap">
      <swiper class="banner-swiper" :options="bannerSwiperOption">
        <swiper-slide v-for="(v, key) in banners" :key="key">
          <van-image class="banner-img" :src="`${v.url}`" width="100%" height="160px"
            style="object-fit: cover;">
            <template v-slot:loading>
              <van-loading type="circular" />
            </template>
          </van-image>
        </swiper-slide>
      </swiper>
    </div>

    <div class="choose-body">
      <van-list v-model="loading" @load="onLoad">
        <!-- Grid mode -->
        <div class="grid-mode" v-show="!isShow">
          <div class="grid-item" v-for="item in data" :key="item.id" @click="toDetail(item.id)">
            <div class="grid-card">
              <div class="grid-img-box">
                <img :src="item.img_url" class="grid-img" />
                <span class="corner-tag"><i>{{ $t('concubine.high_end') }}</i></span>
                <div class="grid-overlay">
                  <div class="grid-appointment">{{ $t('concubine.appointment') }}</div>
                </div>
              </div>
              <div class="grid-footer">
                <div class="grid-name">
                  <span class="dot"></span>
                  <span>{{ item.xuanfei_name }}</span>
                </div>
                <div class="grid-likes">
                  <van-icon name="like" color="#dc63a1" />
                  <span>{{ item.dianzan }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- List mode -->
        <div class="list-mode" v-show="isShow">
          <div class="list-item" v-for="item in data" :key="item.id" @click="toDetail(item.id)">
            <div class="list-img-box">
              <div class="van-image" style="width: 120px; height: 120px; overflow: hidden; border-radius: 12px;">
                <img :src="item.img_url" class="van-image__img" style="object-fit: cover;" />
              </div>
              <span class="corner-tag"><i>{{ $t('concubine.high_end') }}</i></span>
            </div>
            <div class="list-info">
              <div class="list-tags">
                <div class="list-tag">
                  <img src="/img/vip.png" style="width: 13px; height: 13px;" />
                  <span>{{$t("index.authentication")}}</span>
                </div>
                <div class="list-tag">
                  <img src="/img/vip.png" class="van-image__img" style="width: 13px; height: 13px;" />
                  <span>{{$t("index.video_authentication")}}</span>
                </div>
                <div class="list-tag list-name-tag">{{ item.xuanfei_name }}</div>
              </div>
              <div class="tags-row">
                <van-tag v-for="(tag, index) in item.flagArray" :key="index" :type="tagTypes[index]">
                  {{ tag }}
                </van-tag>
              </div>
              <div class="list-rate">
                <span class="rate-label">{{$t("index.toll")}}：</span>
                <van-rate v-model="item.number" color="#ffd21e" size="16px" />
              </div>
              <div class="list-meta">
                {{$t("index.height")}}: {{item.hight}}cm {{$t("index.bust")}}：{{ item.bust }}
                {{$t("index.address")}}：{{$t("index.National")}}：{{$t("index.yes")}}
              </div>
              <div class="action-btn">{{$t("index.about")}}</div>
            </div>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        isShow: false,
        banners: [{}],
        basicData: [],
        active: 0,
        data: [],
        loading: false,
        page: 0,
        tagTypes: ['primary', 'success', 'danger', 'warning'],
        bannerSwiperOption: {
          effect: "coverflow",
          grabCursor: true,
          centeredSlides: true,
          slidesPerView: "auto",
          speed: 800,
          autoplay: true,
          coverflowEffect: {
            rotate: 50,
            stretch: 10,
            depth: 100,
            modifier: 1,
            slideShadows: true,
          },
        },
      };
    },
    methods: {
      getxuanfeilist() {
        const selid = this.getCookie('selid');
        this.$http({
          method: "get",
          url: "xuanfeilist",
          data: { id: selid, page: this.page },
        }).then((res) => {
          this.data = res.data;
          const lanng = localStorage.getItem("lang");
          this.data.forEach(item => {
            const parts = item.flag.split('|')
            lanng == 'zh' ? item.flag = parts[0] : lanng == 'en' ? item.flag = parts[1] :
              lanng == 'ja' ? item.flag = parts[2] : item.flag = parts[3]
            item.flagArray = item.flag.split('，');
          })
        });
      },
      onLoad() {},
      toDetail(id) {
        this.$router.push({ path: "/detail", query: { id } });
      },
      getCookie(name) {
        name = name + '=';
        const decodedCookie = decodeURIComponent(document.cookie);
        const cookies = decodedCookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
          let cookie = cookies[i];
          while (cookie.charAt(0) === ' ') {
            cookie = cookie.substring(1);
          }
          if (cookie.indexOf(name) === 0) {
            return cookie.substring(name.length, cookie.length);
          }
        }
        return '';
      },
      getBasicConfig() {
        const selid = this.getCookie('selid');
        this.$http({
          method: "get",
          url: "sys_config",
          data: { id: selid },
        }).then((res) => {
          this.basicData = res.data;
          this.getBanner(this.basicData);
        });
      },
      getBanner(data) {
        this.banners = data.banners;
      },
    },
    created() {
      this.getBasicConfig();
      this.getxuanfeilist();
    },
  };
</script>

<style lang="less" scoped>
.choose-page {
  background: #f6f5f2;
}

.banner-wrap {
  padding: 12px;
}

.banner-swiper {
  border-radius: var(--radius-lg);
  overflow: hidden;
}

.choose-body {
  padding: 0 12px 80px;
}

/* Grid mode */
.grid-mode {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.grid-item {
  width: calc(50% - 6px);
}

.grid-card {
  background: rgba(255,255,255,.74);
  border-radius: var(--radius-md);
  overflow: hidden;
  box-shadow: var(--shadow-soft);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(255,255,255,.72);
  cursor: pointer;
  transition: transform .2s ease;

  &:active {
    transform: scale(.97);
  }
}

.grid-img-box {
  position: relative;
  height: 260px;
  overflow: hidden;
}

.grid-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.corner-tag {
  position: absolute;
  z-index: 9;
  background-color: #ebcaaf;
  color: #8d684b;
  transform: rotate(45deg);
  width: 80px;
  height: 80px;
  top: -44px;
  right: -44px;

  i {
    position: absolute;
    bottom: 5px;
    left: 50%;
    transform: translateX(-50%);
    font-weight: 700;
    font-size: 24px;
  }
}

.grid-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0,0,0,.4);
  display: flex;
  align-items: center;
  padding: 8px 12px;
  color: #fff;
}

.grid-appointment {
  border: 1px solid rgba(255,255,255,.8);
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 24px;
  margin-left: auto;
}

.grid-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px;
  font-size: 26px;
  color: #666;
}

.grid-name {
  display: flex;
  align-items: center;
  gap: 6px;

  .dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #efba8f;
    display: inline-block;
  }
}

.grid-likes {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #999;
}

/* List mode */
.list-mode {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.list-item {
  display: flex;
  gap: 12px;
  padding: 12px;
  background: rgba(255,255,255,.74);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-soft);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(255,255,255,.72);
  cursor: pointer;
  transition: transform .2s ease;

  &:active {
    transform: scale(.99);
  }
}

.list-img-box {
  position: relative;
  overflow: hidden;
  border-radius: 12px;
  flex-shrink: 0;
}

.list-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.list-tags {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.list-tag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: linear-gradient(180deg, #e7caaf, #fff7ed);
  color: #a4826b;
  font-weight: 600;
  font-size: 22px;
  padding: 2px 8px;
  border-radius: 999px;
}

.list-name-tag {
  width: 70px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.list-rate {
  display: flex;
  align-items: center;
  gap: 4px;
}

.rate-label {
  font-size: 28px;
  color: #666;
}

.list-meta {
  color: #999;
  font-size: 24px;
}

.action-btn {
  background: var(--gradient-primary);
  color: #fff;
  border-radius: var(--radius-sm);
  padding: 10px 0;
  text-align: center;
  font-size: 26px;
  font-weight: 600;
  margin-top: 2px;
}
</style>
